import { render, staticRenderFns } from "./CustomerHours.vue?vue&type=template&id=1467a774&scoped=true&"
import script from "./CustomerHours.vue?vue&type=script&lang=ts&"
export * from "./CustomerHours.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerHours.vue?vue&type=style&index=0&id=1467a774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1467a774",
  null
  
)

export default component.exports